import type { AxiosRequestConfig } from 'axios';
import type z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';
import { FamilyCommunicationsDtoSchema } from '../contracts';

export const GetFamilyCommunicationsResponseDtoSchema =
  PagePaginationResponseDtoSchema(FamilyCommunicationsDtoSchema);

export type GetFamilyCommunicationsResponseDto = z.infer<
  typeof GetFamilyCommunicationsResponseDtoSchema
>;
export type GetFamilyCommunicationsRequestDto = PagePaginationRequestDto<
  { id: number },
  'title' | 'date' | 'uploadedBy'
>;

export const getFamilyCommunications = (
  params: GetFamilyCommunicationsRequestDto,
  config?: AxiosRequestConfig<GetFamilyCommunicationsRequestDto>
) => {
  const { id, ...restParams } = params;

  return api
    .get(`family-communication/resident/${id}`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetFamilyCommunicationsResponseDtoSchema));
};
